package com.rosario.juridico.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class NormativasRoot(
    val ley13151: Ley13151
)

@Serializable
data class Ley13151(
    val id: String,
    val nombre: String,
    val materias: Map<String, MateriaMediacion>,
    val reglas: ReglasMediacion,
    val textoInformativoGeneral: String
)

@Serializable
data class MateriaMediacion(
    val id: String,
    val nombre: String,
    val minimoSinMonto: Double,
    val tope: Double,
    val plusMixtoBase: Double,
    val escala: List<TramoEscalaMediacion>,
    val textoInformativo: String
)

@Serializable
data class TramoEscalaMediacion(
    val hasta: Double,
    val honorario: Double
)

@Serializable
data class ReglasMediacion(
    val desistimiento: ReglaDesistimiento,
    val inasistencia: ReglaInasistencia,
    val reuniones: ReglaReuniones,
    val comediador: ReglaComediador,
    val alimentos: ReglaAlimentos,
    val aportes: ReglaAportes,
    val gastosAdministrativos: ReglaGastosAdmin
)

@Serializable
data class ReglaDesistimiento(
    val antesNotificacionFactor: Double,
    val antesNotificacionMinimoJus: Double,
    val despuesNotificacionFactor: Double
)

@Serializable
data class ReglaInasistencia(
    val cobroRequirente: Double,
    val multaJus: Double,
    val honorarioFijoAsignado: Double
)

@Serializable
data class ReglaReuniones(
    val umbralExceso: Int,
    val valorPorReunionExcedente: Double
)

@Serializable
data class ReglaComediador(
    val incrementoFactor: Double
)

@Serializable
data class ReglaAlimentos(
    val multiplicadorMeses: Double
)

@Serializable
data class ReglaAportes(
    val tasaEstandar: Double,
    val tasaAlta: Double
)

@Serializable
data class ReglaGastosAdmin(
    val valorInicialJus: Double
)
